/**
 * Asset States API
 * Handles all asset state-related API calls
 */
import apiClient from './apiClient';
import {
  AssetState,
  AssetStatesListResponse,
  CreateAssetStateData,
  UpdateAssetStateData,
} from '../types';

export interface AssetStatesQueryParams {
  include_inactive?: boolean;
}

export const assetStatesApi = {
  /**
   * Get all asset states
   */
  getStates: async (params?: AssetStatesQueryParams): Promise<AssetStatesListResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.include_inactive) queryParams.append('include_inactive', 'true');

    const query = queryParams.toString();
    return apiClient.get<AssetStatesListResponse>(`/asset-states${query ? `?${query}` : ''}`);
  },

  /**
   * Get a specific state by ID
   */
  getState: async (stateId: number): Promise<{ state: AssetState }> => {
    return apiClient.get<{ state: AssetState }>(`/asset-states/${stateId}`);
  },

  /**
   * Create a new state
   */
  createState: async (data: CreateAssetStateData): Promise<{ message: string; state: AssetState }> => {
    return apiClient.post<{ message: string; state: AssetState }>('/asset-states', data);
  },

  /**
   * Update an existing state
   */
  updateState: async (
    stateId: number,
    data: UpdateAssetStateData
  ): Promise<{ message: string; state: AssetState }> => {
    return apiClient.put<{ message: string; state: AssetState }>(`/asset-states/${stateId}`, data);
  },

  /**
   * Delete (soft delete) a state
   */
  deleteState: async (stateId: number): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>(`/asset-states/${stateId}`);
  },
};

export default assetStatesApi;
